import type { ReactNode } from 'react';
import type { ToolId } from '@canvas/shared-types';

/** Shared SVG icons for tool strip / menus (stroke currentColor). */
export const TOOL_ICONS: Partial<Record<ToolId, ReactNode>> = {
  move: (
    <svg viewBox="0 0 24 24">
      <path d="M4 4l7 16 2-6 6-2z" />
    </svg>
  ),
  'marquee-rect': (
    <svg viewBox="0 0 24 24">
      <rect x="5" y="5" width="14" height="14" strokeDasharray="3 2" />
    </svg>
  ),
  lasso: (
    <svg viewBox="0 0 24 24">
      <path d="M6 8c2-4 10-4 12 0 2 4-2 8-4 10-3 2-8 1-9-3-1-3 1-5 1-7z" strokeDasharray="3 2" />
    </svg>
  ),
  brush: (
    <svg viewBox="0 0 24 24">
      <path d="M14 4l6 6-10 10H4v-6L14 4z" />
    </svg>
  ),
  pencil: (
    <svg viewBox="0 0 24 24">
      <path d="M4 20l4-1 11-11-3-3L5 16l-1 4zM14 6l3 3" />
    </svg>
  ),
  eraser: (
    <svg viewBox="0 0 24 24">
      <path d="M16 3l5 5-9 9H7l-4-4 9-9zM7 17h5" />
    </svg>
  ),
  pen: (
    <svg viewBox="0 0 24 24">
      <path d="M12 20l8-8-4-4-8 8v4h4zM14 6l4 4" />
      <path d="M4 20h4" />
    </svg>
  ),
  'shape-rect': (
    <svg viewBox="0 0 24 24">
      <rect x="5" y="6" width="14" height="12" />
    </svg>
  ),
  'shape-rounded': (
    <svg viewBox="0 0 24 24">
      <rect x="5" y="6" width="14" height="12" rx="3" ry="3" />
    </svg>
  ),
  'shape-ellipse': (
    <svg viewBox="0 0 24 24">
      <ellipse cx="12" cy="12" rx="8" ry="6" />
    </svg>
  ),
  'shape-triangle': (
    <svg viewBox="0 0 24 24">
      <path d="M12 4l9 16H3z" />
    </svg>
  ),
  'shape-polygon': (
    <svg viewBox="0 0 24 24">
      <path d="M12 3l7.5 5.5v7L12 21l-7.5-5.5v-7z" />
    </svg>
  ),
  'shape-star': (
    <svg viewBox="0 0 24 24">
      <path d="M12 3l2.4 6.2H21l-5 4.2 1.8 6.6L12 16.5 6.2 20l1.8-6.6-5-4.2h6.6z" />
    </svg>
  ),
  'shape-line': (
    <svg viewBox="0 0 24 24">
      <path d="M4 18L18 4" />
    </svg>
  ),
  'shape-arrow': (
    <svg viewBox="0 0 24 24">
      <path d="M4 18L16 6M16 6h-5M16 6v5" />
    </svg>
  ),
  'type-point': (
    <svg viewBox="0 0 24 24">
      <path d="M5 6h14M12 6v12M8 18h8" />
    </svg>
  ),
  'type-area': (
    <svg viewBox="0 0 24 24">
      <rect x="4" y="5" width="16" height="14" />
      <path d="M7 9h10M7 12h8M7 15h6" />
    </svg>
  ),
  frame: (
    <svg viewBox="0 0 24 24">
      <rect x="4" y="5" width="16" height="14" rx="2" />
      <path d="M4 15l4-4 3 3 3-5 6 6" />
    </svg>
  ),
  gradient: (
    <svg viewBox="0 0 24 24">
      <rect x="5" y="5" width="14" height="14" />
      <path d="M5 5h14M5 9h14M5 13h14M5 17h14" opacity="0.35" />
    </svg>
  ),
  'paint-bucket': (
    <svg viewBox="0 0 24 24">
      <path d="M5 11l7-7 5 5-7 7H5v-5z" />
      <path d="M14 6l3 3" />
      <path d="M4 20c2 0 3-1 3-2s-1-2-3-2" />
    </svg>
  ),
  eyedropper: (
    <svg viewBox="0 0 24 24">
      <path d="M15 3l6 6-2 2-1-1-7 7H7v-4l7-7-1-1zM7 17l-2 4 4-2" />
    </svg>
  ),
  crop: (
    <svg viewBox="0 0 24 24">
      <path d="M6 2v14h14M2 6h14v14M6 6h8v8" />
    </svg>
  ),
  hand: (
    <svg viewBox="0 0 24 24">
      <path d="M8 11V6a1 1 0 012 0v4m2-3V5a1 1 0 012 0v5m2-2v2a1 1 0 012 0V9a1 1 0 012 0v6c0 3-2 5-5 5H11c-2 0-4-1-5-3l-2-3a1.5 1.5 0 012-2l2 1V11z" />
    </svg>
  ),
  zoom: (
    <svg viewBox="0 0 24 24">
      <circle cx="10" cy="10" r="6" />
      <path d="M15 15l5 5M8 10h4M10 8v4" />
    </svg>
  ),
};
